import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc08969a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mt-3" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-d-inline-block" }
const _hoisted_4 = { class: "f-size-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Panel, {
      header: "บัญชีธนาคาร",
      toggleable: true,
      collapsed: _ctx.isCollapsed,
      "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCollapsed) = $event))
    }, {
      icons: _withCtx(() => [
        _createElementVNode("span", {
          class: "text-gray-1 f-size-14",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
        }, "ดูรายละเอียด")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index + 'bankRadio',
              class: "bank-space"
            }, [
              _createElementVNode("img", {
                class: "p-mx-2 p-align-baseline",
                src: item.imageUrl,
                style: {"width":"30px","height":"30px"}
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(item.bankName) + " (" + _toDisplayString(item.accountNo) + ")", 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.accountName), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["collapsed"])
  ]))
}